import {Tooltip} from 'bootstrap';

let observer = new MutationObserver(mutations  => {
    for(let mutation of mutations) {
        for(let node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.hasAttribute('data-bs-toggle') || node.querySelector('[data-bs-toggle]')) {
            console.log(node);
            update()
          }
        }
      }
});

const config = {
    childList: true,
    subtree: true,
    attributeFilter: ['data-bs-toggle'],
}

function update(){
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')

    for (let index = 0; index < tooltipTriggerList.length; index++) {
        const item = tooltipTriggerList[index];
        let tooltip = new Tooltip(item,
            {
                placement: 'top',
                html: true,
            })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.querySelector('body'), config);
    update()
})